import {
  calendarDateKey,
  calendarFormat,
  calendarInstant,
} from 'dashboard/routes/dashboard/calendar/calendarTime';

export const appointmentBadge = (event, now = new Date()) => {
  const date = calendarInstant(event?.starts_at);
  if (Number.isNaN(date.getTime())) return null;

  // Compare civil days in Brasília, independent of the browser's time zone.
  const dateKey = calendarDateKey(date);
  const todayKey = calendarDateKey(now);
  const days = (Date.parse(dateKey) - Date.parse(todayKey)) / 86400000;
  let day;
  if (days === 0) day = 'Hoje';
  else if (days === 1) day = 'Amanhã';
  else if (days > 1 && days < 7) {
    const weekday = calendarFormat(date, { weekday: 'long' }).replace(
      '-feira',
      ''
    );
    day = weekday.charAt(0).toUpperCase() + weekday.slice(1);
  } else {
    day = calendarFormat(date, {
      day: '2-digit',
      month: '2-digit',
      ...(dateKey.slice(0, 4) !== todayKey.slice(0, 4)
        ? { year: 'numeric' }
        : {}),
    });
  }
  const time = event.all_day
    ? ' · Dia inteiro'
    : `, ${calendarFormat(date, { hour: '2-digit', minute: '2-digit' })}`;
  const fullDate = calendarFormat(date, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  return {
    label: `Agendado: ${day}${time}`,
    tooltip: `${fullDate}${time} · Horário de Brasília · ${event.title || ''}`,
  };
};
